import { cn } from '@core/utils';
import React from 'react';

interface AgencyBannerProps {
  className?: string;
}

export const AgencyBanner = ({ className }: AgencyBannerProps) => {
  return (
    <article
      className={cn(
        'hidden gap-20 bg-[#EEF2F7] py-8 mobile-tablet:flex-center',
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="67"
        height="19"
        viewBox="0 0 67 19"
        fill="none"
      >
        <path
          d="M19.0 9.5C19.0 14.75 14.75 19.0 9.5 19.0C4.25 19.0 0 14.74 0 9.5C0 4.25 4.25 0 9.5 0C14.74 0 19.0 4.25 19.0 9.5Z"
          fill="white"
        />
        <path
          d="M13.96 8.83C12.45 7.81 10.52 8.23 9.5 9.77C8.66 11.06 7.38 11.22 6.88 11.22C5.26 11.22 4.16 10.09 3.83 8.91C3.83 8.91 3.83 8.88 3.82 8.87C3.82 8.85 3.82 8.84 3.81 8.83C3.69 8.34 3.65 8.1 3.65 7.58C3.65 4.77 6.54 1.64 10.69 1.64C14.84 1.64 17.37 4.88 18.0 6.68C17.99 6.65 17.98 6.62 17.97 6.58C16.764 3.06 13.42 0.53 9.49 0.53C4.55 0.53 0.54 4.54 0.54 9.48C0.54 13.9 3.73 17.69 8.15 17.69C11.678 17.69 14.05 15.71 15.14 12.99C15.73 11.49 15.31 9.74 13.96 8.82"
          fill="#003668"
        />
        <path
          d="M18.06 6.86C17.53 5.11 15.08 1.65 10.687 1.65C6.54 1.65 3.65 4.78 3.65 7.59C3.65 8.11 3.68 8.34 3.81 8.83C3.76 8.62 3.73 8.4 3.73 8.19C3.73 5.27 6.66 3.24 9.68 3.24C13.76 3.24 17.06 6.55 17.06 10.63C17.06 13.82 15.22 16.59 12.55 17.92C16.0 16.67 18.45 13.37 18.45 9.5C18.45 8.58 18.33 7.77 18.06 6.86"
          fill="#E6002D"
        />
        <path
          d="M25.13 5.7V4.99H26.25V5.7H27.81V6.58H23.39V5.7H25.13ZM27.63 8.58C27.63 8.83 27.58 9.06 27.47 9.28C27.37 9.49 27.23 9.68 27.05 9.84C26.88 10.01 26.676 10.14 26.44 10.23C26.21 10.32 25.96 10.37 25.7 10.37C25.43 10.37 25.18 10.32 24.95 10.23C24.72 10.14 24.516 10.0 24.34 9.84C24.16 9.69 24.02 9.49 23.92 9.28C23.82 9.06 23.76 8.83 23.76 8.58C23.76 8.33 23.81 8.1 23.92 7.88C24.02 7.66 24.16 7.48 24.34 7.31C24.51 7.15 24.72 7.02 24.95 6.92C25.18 6.83 25.43 6.78 25.7 6.78C25.96 6.78 26.21 6.83 26.44 6.92C26.67 7.02 26.88 7.15 27.05 7.31C27.23 7.48 27.37 7.66 27.47 7.88C27.57 8.1 27.63 8.33 27.63 8.58ZM26.65 8.57C26.65 8.32 26.55 8.1 26.37 7.91C26.19 7.73 25.96 7.64 25.7 7.64C25.44 7.64 25.22 7.73 25.04 7.91C24.853 8.1 24.76 8.32 24.76 8.57C24.76 8.83 24.853 9.04 25.04 9.23C25.22 9.41 25.44 9.5 25.7 9.5C25.96 9.5 26.19 9.41 26.37 9.23C26.55 9.04 26.65 8.83 26.65 8.57ZM30.373 12.02C30.373 12.28 30.32 12.53 30.2 12.76C30.09 12.98 29.95 13.19 29.77 13.36C29.58 13.54 29.36 13.68 29.11 13.78C28.87 13.88 28.6 13.94 28.32 13.94C28.04 13.94 27.77 13.89 27.52 13.78C27.27 13.68 27.05 13.54 26.86 13.36C26.68 13.19 26.54 12.98 26.43 12.76C26.31 12.53 26.26 12.28 26.26 12.02C26.26 11.76 26.32 11.51 26.43 11.28C26.54 11.04 26.68 10.84 26.86 10.67C27.05 10.493 27.27 10.35 27.52 10.25C27.77 10.15 28.04 10.09 28.32 10.09C28.6 10.09 28.86 10.14 29.11 10.25C29.36 10.35 29.58 10.493 29.77 10.67C29.95 10.84 30.09 11.05 30.2 11.28C30.32 11.51 30.373 11.76 30.373 12.02ZM29.34 12.01C29.34 11.74 29.24 11.5 29.04 11.29C28.836 11.09 28.596 10.99 28.32 10.99C28.04 10.99 27.8 11.1 27.6 11.29C27.4 11.5 27.3 11.73 27.3 12.01C27.3 12.29 27.41 12.52 27.6 12.72C27.8 12.92 28.04 13.02 28.32 13.02C28.6 13.02 28.84 12.92 29.04 12.72C29.24 12.52 29.34 12.29 29.34 12.01ZM29.32 9.82H28.35V5.18H29.32V7.02H30.19V5.167H31.21V9.94H30.19V7.98H29.32V9.82Z"
          fill="#575756"
        />
        <path
          d="M32.436 6.32V5.41H37.32V6.32H35.24L37.4 8.97L36.66 9.57L34.93 7.4L33.2 9.72L32.43 9.09L34.59 6.32H32.436ZM39.19 11.87C39.19 12.15 39.14 12.42 39.02 12.67C38.9 12.92 38.74 13.14 38.55 13.33C38.35 13.522 38.11 13.67 37.84 13.78C37.57 13.89 37.282 13.95 36.99 13.95C36.69 13.95 36.4 13.89 36.13 13.78C35.85 13.67 35.62 13.522 35.42 13.33C35.22 13.14 35.07 12.92 34.95 12.67C34.83 12.42 34.77 12.15 34.77 11.87C34.77 11.58 34.83 11.31 34.95 11.06C35.07 10.8 35.22 10.58 35.42 10.39C35.62 10.2 35.86 10.05 36.13 9.94C36.4 9.83 36.69 9.78 36.99 9.78C37.282 9.78 37.57 9.84 37.84 9.94C38.11 10.05 38.34 10.2 38.55 10.39C38.74 10.58 38.9 10.8 39.02 11.06C39.14 11.31 39.19 11.58 39.19 11.87ZM38.16 11.86C38.16 11.54 38.04 11.265 37.8 11.03C37.57 10.8 37.29 10.68 36.98 10.68C36.659 10.68 36.38 10.8 36.15 11.03C35.92 11.26 35.8 11.54 35.8 11.86C35.8 12.179 35.92 12.45 36.15 12.68C36.38 12.91 36.65 13.02 36.98 13.02C37.3 13.02 37.573 12.91 37.8 12.68C38.04 12.45 38.16 12.179 38.16 11.86ZM38.86 9.68V7.83H37.28V6.92H38.86V5.17H39.92V9.68H38.86Z"
          fill="#575756"
        />
        <path
          d="M45.99 7.55C45.99 7.86 45.93 8.17 45.8 8.45C45.67 8.73 45.5 8.97 45.28 9.19C45.059 9.4 44.8 9.56 44.51 9.69C44.22 9.81 43.91 9.87 43.58 9.87C43.25 9.87 42.93 9.81 42.64 9.69C42.35 9.56 42.1 9.4 41.88 9.19C41.66 8.97 41.48 8.73 41.36 8.45C41.23 8.17 41.168 7.87 41.168 7.55C41.168 7.23 41.23 6.93 41.36 6.65C41.48 6.37 41.66 6.12 41.88 5.91C42.1 5.7 42.35 5.54 42.64 5.41C42.93 5.29 43.25 5.22 43.58 5.22C43.91 5.22 44.22 5.29 44.51 5.41C44.8 5.53 45.059 5.7 45.28 5.91C45.5 6.12 45.67 6.37 45.8 6.65C45.93 6.93 45.99 7.23 45.99 7.55ZM42.76 10.66V12.57H48.48V13.5H41.699V10.66H42.76ZM44.97 7.56C44.97 7.37 44.94 7.19 44.86 7.02C44.78 6.85 44.69 6.7 44.56 6.57C44.43 6.45 44.288 6.35 44.12 6.28C43.96 6.2 43.78 6.16 43.59 6.16C43.4 6.16 43.22 6.2 43.05 6.28C42.88 6.35 42.74 6.45 42.6 6.57C42.48 6.7 42.38 6.85 42.31 7.02C42.23 7.19 42.19 7.37 42.19 7.56C42.19 7.75 42.23 7.93 42.31 8.09C42.38 8.25 42.48 8.41 42.6 8.53C42.74 8.66 42.88 8.76 43.05 8.83C43.22 8.91 43.4 8.94 43.59 8.94C43.78 8.94 43.96 8.91 44.12 8.83C44.288 8.75 44.43 8.66 44.56 8.53C44.69 8.41 44.79 8.25 44.86 8.09C44.94 7.93 44.97 7.75 44.97 7.56ZM48.26 10.62H47.2V5.17H48.26V7.02H49.48V8.07H48.26V10.62Z"
          fill="#575756"
        />
        <path
          d="M50.24 6.32V5.41H55.12V6.32H53.06L55.22 9.5L54.41 10.04L52.73 7.48L51.05 10.11L50.23 9.56L52.38 6.32H50.24V6.32ZM50.83 13.51V10.67H51.89V12.57H57.81V13.51H50.835H50.83ZM56.67 10.62V8.1H55.08V7.17H56.67V5.17H57.72V10.62H56.67Z"
          fill="#575756"
        />
        <path
          d="M59.18 10.55H66.99V11.48H63.62V13.67H62.55V11.48H59.18V10.55H59.18ZM60.85 6.39H65.32V5.32H66.37V9.41H59.81V5.32H60.85V6.39H60.85ZM65.32 7.31H60.84V8.48H65.32V7.31Z"
          fill="#575756"
        />
      </svg>
      <div className="h-[1.474rem] w-1 bg-[#B9C8D9]" />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="85"
        height="16"
        viewBox="0 0 85 16"
        fill="none"
      >
        <path
          d="M4.24 11.34V4.17H6.77V0H0V15.51H10.1V11.34H4.24Z"
          fill="#003CDF"
        />
        <path
          d="M16.16 0H8.6V4.17H11.93V15.51H16.16V0Z"
          fill="#FF0054"
        />
        <path
          d="M10.1 15.513H0L4.24 11.34H10.1V15.513Z"
          fill="#005BFF"
        />
        <path d="M0 0H6.77V4.17H4.24L0 0Z" fill="#0038AA" />
        <path d="M16.16 0H8.6V4.17H11.93L16.16 0Z" fill="#D2003C" />
        <path
          d="M31.52 5.15H33.42V3.96H28.51V5.15H30.27V6.55L27.99 10.47L29.0 11.1L30.89 7.9L32.7 11.0L33.72 10.37L31.52 6.55V5.15Z"
          fill="#3A3A3A"
        />
        <path
          d="M47.99 3.86H46.74V6.56L44.48 10.47L45.5 11.11L47.36 7.9L49.19 11.0L50.21 10.38L47.99 6.56V3.86Z"
          fill="#3A3A3A"
        />
        <path
          d="M27.08 3.73H25.834V12.38H27.08V3.73Z"
          fill="#3A3A3A"
        />
        <path
          d="M21.3 5.15H24.55V3.96H20.06V10.98H25.11V9.78H21.3V5.15Z"
          fill="#3A3A3A"
        />
        <path
          d="M35.62 3.73H34.377V12.38H35.62V3.73Z"
          fill="#3A3A3A"
        />
        <path
          d="M60.42 3.73H59.18V12.38H60.42V3.73Z"
          fill="#3A3A3A"
        />
        <path
          d="M50.89 5.97H49.06V7.17H50.89V12.38H52.13V3.73H50.89V5.97Z"
          fill="#3A3A3A"
        />
        <path
          d="M74.76 6.77H73.86V3.73H72.64V12.38H73.86V7.96H74.76V12.38H75.97V3.73H74.76V6.77Z"
          fill="#3A3A3A"
        />
        <path
          d="M68.37 5.15H70.61V10.98H71.82V3.96H68.37V5.15Z"
          fill="#3A3A3A"
        />
        <path
          d="M83.22 5.29V3.73H82.06V8.13H83.22V6.39H84.47V5.29H83.22Z"
          fill="#3A3A3A"
        />
        <path
          d="M41.57 6.82H38.01V6.35H40.68V5.42H38.01V4.93H41.42V3.84H36.84V7.9H41.57V6.82Z"
          fill="#3A3A3A"
        />
        <path
          d="M41.33 5.36V6.38H42.43V7.94H43.6V3.73H42.43V5.36H41.33Z"
          fill="#3A3A3A"
        />
        <path
          d="M38.87 10.814H43.6V8.35H37.7V9.42H42.43V9.83H37.7V12.38H43.72V11.3H38.87V10.814Z"
          fill="#3A3A3A"
        />
        <path
          d="M56.9 6.41H54.71V3.96H53.47V10.98H58.136V3.96H56.9V6.41ZM54.71 7.6H56.9V9.79H54.71V7.6Z"
          fill="#3A3A3A"
        />
        <path
          d="M81.264 3.84H80.1V4.81H78.27V3.84H77.11V8.1H81.27V3.84H81.264ZM78.26 5.91H80.1V6.99H78.26V5.91Z"
          fill="#3A3A3A"
        />
        <path
          d="M69.21 10.87H61.459V12.04H69.21V10.87Z"
          fill="#3A3A3A"
        />
        <path
          d="M62.38 9.6L65.29 6.91L68.19 9.6L69.01 8.72L65.91 5.79V3.86H64.67V5.79L61.56 8.72L62.38 9.6Z"
          fill="#3A3A3A"
        />
        <path
          d="M81.21 8.45C80.04 8.45 79.1 9.39 79.1 10.55C79.1 11.72 80.04 12.66 81.21 12.66C82.37 12.66 83.32 11.72 83.32 10.55C83.32 9.39 82.37 8.45 81.21 8.45ZM81.21 11.504C80.69 11.504 80.26 11.08 80.26 10.56C80.26 10.04 80.69 9.61 81.21 9.61C81.73 9.61 82.15 10.04 82.15 10.56C82.15 11.08 81.73 11.504 81.21 11.504Z"
          fill="#3A3A3A"
        />
      </svg>
    </article>
  );
};
